module.exports = __webpack_public_path__ + "img/point.e448b6ae.png";